<template>
  <el-input
    v-model="numberValue"
    :maxlength="maxLength"
    :min="min"
    :max="max"
    show-word-limit
    :disabled="disabled"
    :placeholder="placeholder"
    :readonly="readonly"
    :class="{ readonly: readonly }"
  />
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      required: false,
      default: null,
    },
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: [String, Number],
      required: false,
      default: null,
    },
    min: {
      type: Number,
      required: false,
      default: null,
    },
    max: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    numberValue: {
      get() {
        return this.value;
      },
      set(val) {
        const onlyDigits = val.replace(/[^\d]/g, "");
        const addSign = val[0] === "-" ? "-" + onlyDigits : onlyDigits;
        const toInteger = onlyDigits.length ? parseInt(addSign) : addSign;

        this.$emit("input", val === "" ? undefined : toInteger);
      },
    },
  },
};
</script>
